module.exports = __webpack_public_path__ + "3532cace39c1af7cbd8305208675ed1c.png";